
export const useTheme = () => {
    // Use useState to share state across components (server-side friendly in Nuxt 3)
    // defaulting to true (dark mode) as seen in AppHeader
    const isDark = useState<boolean>('theme-dark', () => true)

    const toggleTheme = () => {
        isDark.value = !isDark.value
        updateDOM()
    }

    const setDark = (value: boolean) => {
        isDark.value = value
        updateDOM()
    }

    const updateDOM = () => {
        if (import.meta.client) {
            if (isDark.value) {
                document.documentElement.classList.add('dark')
            } else {
                document.documentElement.classList.remove('dark')
            }
        }
    }

    // Initialize DOM on mount (client-side only)
    const initTheme = () => {
        if (import.meta.client) {
            updateDOM()
        }
    }

    return {
        isDark,
        toggleTheme,
        setDark,
        initTheme
    }
}
